import { QueryClient } from "@tanstack/react-query";
import Bugsnag from "~/lib/Bugsnag";
import { Build } from "~/components/build/Show/lib/types";
import { AnnotationScope } from "~/components/build/Show/lib/types/Annotation";
import { allAnnotationsQueryKey } from "~/components/build/Show/lib/queries/allAnnotations";
import { allBuildAnnotationsQueryKey } from "~/components/build/Show/lib/queries/allBuildAnnotations";
import { allJobAnnotationsQueryKey } from "~/components/build/Show/lib/queries/allJobAnnotations";
import { jobQueryKey } from "~/components/build/Show/lib/queries/job";

export function annotationsChangedHandler(
  queryClient: QueryClient,
  buildId: Build["id"],
  scope: AnnotationScope,
  jobUuid?: string,
): void {
  // Always invalidate the "all" tab
  queryClient.invalidateQueries({
    queryKey: allAnnotationsQueryKey(buildId),
    exact: true,
  });

  switch (scope) {
    case "build":
      queryClient.invalidateQueries({
        queryKey: allBuildAnnotationsQueryKey(buildId),
        exact: true,
      });
      break;
    case "job":
      queryClient.invalidateQueries({
        queryKey: allJobAnnotationsQueryKey(buildId),
        exact: true,
      });
      if (jobUuid) {
        // TODO: use job annotations query key once count is no longer in the key
        // See app/javascript/components/build/Show/lib/queries/jobAnnotations.ts:6
        queryClient.invalidateQueries({
          queryKey: ["build", buildId, "jobs", jobUuid, "annotations"],
          exact: false,
        });
        queryClient.invalidateQueries({
          queryKey: jobQueryKey(buildId, jobUuid),
          exact: true,
        });
      }
      break;
    default:
      Bugsnag.notify(`[annotationsChangedHandler] Unknown annotation scope: ${scope}`);
      break;
  }
}
